// ============================================================
// Script 1: posicionament del widget <shopify-chat>
// Estructura real:
//   shopify-chat #shadow > shopify-agent-runtime #shadow > .activator-nudge
// ============================================================
(function () {
  const MOBILE_BP = 768;
  let chat = null;
  let root = null;          // shadow root INTERN (shopify-agent-runtime)
  let innerObserver = null;
  let buyButton = null;
  let stickyCart = null;
  let raf;

  function getChatEl() {
    return document.querySelector('shopify-chat') || document.getElementById('ShopifyChat');
  }

  function getInnerRoot(el) {
    const runtime = el && el.shadowRoot &&
      el.shadowRoot.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot ? runtime.shadowRoot : null;
  }

  function setVar(name, value) {
    if (!chat) return;
    if (value === null) chat.style.removeProperty(name);
    else chat.style.setProperty(name, value);
  }

  function isChatOpen() {
    const btn = root && root.querySelector('.activator, [part="activator"]');
    return btn ? btn.getAttribute('aria-expanded') === 'true' : false;
  }

  function injectStyles() {
    if (!root || root.getElementById('cv-chat-styles')) return;
    const style = document.createElement('style');
    style.id = 'cv-chat-styles';
    style.textContent = `
      .activator-nudge {
        top: auto !important;
        left: auto !important;
        bottom: var(--cv-chat-bottom, 20px) !important;
        right:  var(--cv-chat-right, 20px) !important;
        transform: scale(var(--cv-chat-scale, 1)) !important;
        transform-origin: bottom right;
        visibility: var(--cv-chat-visibility, visible) !important;
        transition: bottom .3s ease, right .3s ease, transform .3s ease, visibility .3s ease;
      }
    `;
    root.appendChild(style);
  }

  function schedule() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(adjustChat);
  }

  function observeRoot() {
    if (innerObserver) innerObserver.disconnect();
    // IMPRESCINDIBLE: l'obertura del xat passa dins el shadow root intern
    innerObserver = new MutationObserver(schedule);
    innerObserver.observe(root, {
      attributes: true, subtree: true, childList: true,
      attributeFilter: ['aria-expanded', 'class', 'hidden']
    });
  }

  // Si Shopify re-renderitza el runtime, tornem a enganxar estil i observer
  function refreshRoot() {
    const r = getInnerRoot(chat);
    if (r && r !== root) {
      root = r;
      injectStyles();
      observeRoot();
    } else if (root && !root.getElementById('cv-chat-styles')) {
      injectStyles();
    }
  }

  function adjustChat() {
    if (!chat) return;
    refreshRoot();

    const isMobile = window.innerWidth <= MOBILE_BP;
    const open = isChatOpen();

    if (document.body.classList.contains('cv-popup-open') && isMobile) {
      setVar('--cv-chat-visibility', 'hidden');
      return;
    }

    const menuDrawer = document.querySelector('.menu-drawer');
    const cartDrawer = document.querySelector('cart-drawer');
    const isMenuOpen = menuDrawer && menuDrawer.hasAttribute('open');
    const isCartDrawerOpen = cartDrawer &&
      (cartDrawer.hasAttribute('open') || cartDrawer.hasAttribute('active'));
    const isFacetDrawerOpen = isMobile && document.querySelector('#FacetDrawer[open]');
    const isQuickViewOpen = isMobile && document.querySelector('quick-view-modal[open]');
    const isImageModalOpen = isMobile && (
      document.querySelector('.pswp--open') ||
      document.querySelector('.photoswipe--open') ||
      document.body.classList.contains('pswp-open')
    );
    const isProductPage = document.body.classList.contains('product-template');

    const isBuyButtonVisible = buyButton ? (() => {
      const rect = buyButton.getBoundingClientRect();
      const margin = isMobile ? 0 : 130;
      return rect.bottom > margin && rect.top < window.innerHeight;
    })() : true;

    const isStickyVisible = stickyCart &&
      stickyCart.classList.contains('sticky-atc-bar--show') &&
      (isMobile ? stickyCart.classList.contains('scrolled') : !isBuyButtonVisible);

    // --- Assistent Celavista (sense canvis) ---
    const bannerEl = document.getElementById('cv-assistant-banner');
    const cvBtn = document.getElementById('cv-assistant-btn-wrapper');
    if (cvBtn && isProductPage && !isMobile) {
      cvBtn.style.bottom = isStickyVisible ? '149px' : '75px';
      cvBtn.style.right = isStickyVisible ? '50px' : '14px';
    }
    const cvPopup = document.querySelector('.cv-assistant-popup');
    if (cvPopup && isProductPage && !isMobile) {
      cvPopup.style.bottom = isStickyVisible ? '204px' : '130px';
      cvPopup.style.right = isStickyVisible ? '50px' : '16px';
    }

    if ((isFacetDrawerOpen || isQuickViewOpen || isCartDrawerOpen) && bannerEl) {
      bannerEl.style.display = 'none';
    } else if (bannerEl && !isFacetDrawerOpen && !isQuickViewOpen && !isCartDrawerOpen &&
               !localStorage.getItem('cv_assistant_closed') && !isMenuOpen &&
               isMobile && !isProductPage) {
      bannerEl.style.display = '';
    }

    const isBannerVisible = isMobile && !isProductPage && bannerEl !== null &&
      bannerEl.style.display !== 'none' &&
      !bannerEl.classList.contains('hidden') &&
      !localStorage.getItem('cv_assistant_closed');

    // --- Visibilitat ---
    if (isImageModalOpen || isCartDrawerOpen || isFacetDrawerOpen || isMenuOpen) {
      setVar('--cv-chat-visibility', 'hidden');
      return;
    }
    setVar('--cv-chat-visibility', 'visible');

    // Amb el panell obert, Shopify ja el posiciona ell: no hi toquem.
    if (open) {
      setVar('--cv-chat-bottom', null);
      setVar('--cv-chat-right', null);
      setVar('--cv-chat-scale', '1');
      return;
    }

    if (isProductPage && isStickyVisible) {
      setVar('--cv-chat-bottom', isMobile ? '78px' : '90px');
      setVar('--cv-chat-right', isMobile ? '8px' : '5rem');
    } else {
      setVar('--cv-chat-bottom', isMobile ? (isBannerVisible ? '78px' : '8px') : '16px');
      setVar('--cv-chat-right', isMobile ? '8px' : '16px');
    }
    setVar('--cv-chat-scale', isMobile ? '0.8' : '1');
  }

  function start(el, innerRoot) {
    chat = el;
    root = innerRoot;
    injectStyles();
    if (window.innerWidth <= MOBILE_BP) setVar('--cv-chat-visibility', 'hidden');

    const run = () => {
      stickyCart = document.querySelector('.sticky-atc-bar');
      buyButton = document.querySelector(
        '.product-form__submit:not(.sticky-atc-bar .product-form__submit)'
      );

      new MutationObserver(schedule).observe(document.body, {
        attributes: true, subtree: true,
        attributeFilter: ['class', 'open', 'active']
      });
      observeRoot();

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      window._adjustChat = adjustChat;
      adjustChat();
    };

    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  // attachShadow() no dispara mutacions: cal fer polling fins que existeixi el root intern
  let tries = 0;
  const wait = setInterval(() => {
    const el = getChatEl();
    const inner = getInnerRoot(el);
    if (inner) { clearInterval(wait); start(el, inner); }
    else if (++tries > 150) clearInterval(wait); // ~15 s
  }, 100);
})();


// ============================================================
// Script badge: amagar l'indicador fins que l'usuari obri el xat
// ============================================================
(function () {
  if (document.cookie.includes('chat_opened=true')) return;

  function getInnerRoot(el) {
    const runtime = el && el.shadowRoot &&
      el.shadowRoot.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot ? runtime.shadowRoot : null;
  }

  function setup(chat) {
    const root = getInnerRoot(chat);
    if (!root) return false;
    if (!root.getElementById('cv-no-badge')) {
      const style = document.createElement('style');
      style.id = 'cv-no-badge';
      style.textContent = '.activator__indicator { display: none !important; }';
      root.appendChild(style);
    }
    // El clic al botó intern travessa la frontera del shadow DOM (composed)
    chat.addEventListener('click', function () {
      document.cookie = 'chat_opened=true; path=/; max-age=31536000';
      const r = getInnerRoot(chat);
      const s = r && r.getElementById('cv-no-badge');
      if (s) s.remove();
    }, { once: true });
    return true;
  }

  let tries = 0;
  const wait = setInterval(() => {
    const chat = document.querySelector('shopify-chat');
    if ((chat && setup(chat)) || ++tries > 150) clearInterval(wait);
  }, 100);
})();

// Script 2: Revi opiniones text removal
function removeOpinionesText() {
  const reviWidgets = document.querySelectorAll('.revi-widget-stars-1');
  
  reviWidgets.forEach(function(widget) {
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT, null, false);
    
    let node;
    while(node = walker.nextNode()) {
      if (node.textContent.includes('opiniones') || node.textContent.includes('opinión') || node.textContent.includes('avaliações') || node.textContent.includes('avaliação') || node.textContent.includes('recensioni') || node.textContent.includes('recensione') || node.textContent.includes('reviews') || node.textContent.includes('review') || node.textContent.includes('avis')) {
        const number = node.textContent.match(/\d+/);
        if (number) {
          node.textContent = ' (' + number[0] + ')';
        }
      }
    }
    
    const text = widget.textContent;
    const number = text.match(/\((\d+)\)/);
    
    if (number && number[1] === '0') {
      widget.classList.add('revi-no-reviews');
    }
  });
}

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      const hasReviWidget = Array.from(mutation.addedNodes).some(node => 
        node.classList && node.classList.contains('revi-widget-stars-1')
      );
      if (hasReviWidget) {
        removeOpinionesText();
      }
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });
window.addEventListener('load', removeOpinionesText);


/* Script 3: Show subscription description only when "Suscríbete" is selected */
(function() {
  function toggleDescription() {
    var desc = document.querySelector('.Avada-Subscription__Description');
    var subBox = document.querySelector('.Avada-Subscription__Box:nth-child(2) .Avada-Subscription__SelectionBox.--Active');
    if (desc) {
      desc.style.cssText = subBox ? 'display: block !important;' : 'display: none !important;';
    }
  }

  const checkInterval = setInterval(function() {
    var container = document.querySelector('.Avada-Subscription__Block');
    if (container) {
      clearInterval(checkInterval);
      
      const observer = new MutationObserver(toggleDescription);
      observer.observe(container, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
      
      toggleDescription();
    }
  }, 200);
})();

// Script 4: Open category filter by default on desktop
document.addEventListener('DOMContentLoaded', function() {
  const facetDrawer = document.querySelector('#FacetDrawer');
  if (facetDrawer) {
    new MutationObserver(() => {
      if (facetDrawer.hasAttribute('open')) {
        const filtreCategoria = facetDrawer.querySelector('.facet-accordion-details[data-index="drawer-filter.p.m.custom.categoria"]');
        if (filtreCategoria && !filtreCategoria.hasAttribute('open')) {
          filtreCategoria.querySelector('summary')?.click();
        }
      }
    }).observe(facetDrawer, { attributes: true, attributeFilter: ['open'] });
  }
  if (window.innerWidth >= 768) {
    var filtreCategoria = document.querySelector('.facet-accordion-details[data-index="vertical-filter.p.m.custom.categoria"]');
    if (filtreCategoria && !filtreCategoria.hasAttribute('open')) {
      var summary = filtreCategoria.querySelector('summary');
      if (summary) summary.click();
    }

    var filtrePreu = document.querySelector('.facet-accordion-details[data-index="vertical-filter.v.price"]');
    if (filtrePreu && filtrePreu.hasAttribute('open')) {
      var summaryPreu = filtrePreu.querySelector('summary');
      if (summaryPreu) summaryPreu.click();
    }
  }
});

// Script 5: Autofocus search input on search page
document.addEventListener('DOMContentLoaded', function() {
  var searchInput = document.getElementById('SearchInput-template--26777635127627__main');
  if (searchInput && window.location.pathname === '/search') {
    searchInput.focus();
  }
});


// Script 6: Sticky ATC bar behavior
// 1. Hide on page load until the buy button has been visible at least once
// 2. Prevent sticky bar from appearing when clicking Avada subscription options
// Funciona con cualquier layout de Avada (1, 4…) y también sin Avada.
(function () {
  let intentos = 0;
  const interval = setInterval(() => {
    const stickyBar = document.querySelector('.sticky-atc-bar');
    const buyButton = document.querySelector('.product-form__submit:not(.sticky-atc-bar .product-form__submit)');

    // Sin barra o sin botón (no es una ficha de producto): se deja de buscar a los ~10 s.
    if (!stickyBar || !buyButton) {
      if (++intentos > 33) clearInterval(interval);
      return;
    }
    clearInterval(interval);

    let blockSticky = false;
    let buttonHasBeenVisible = false;

    const observer = new MutationObserver(() => {
      if (blockSticky && stickyBar.classList.contains('sticky-atc-bar--show')) {
        stickyBar.classList.remove('sticky-atc-bar--show');
      }
    });
    observer.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });

    // Avada puede pintarse después: el clic se escucha en el documento y se filtra por el widget,
    // sea del layout que sea.
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.Avada-SubscriptionWidget-Block, .Avada-Subscription__Container')) return;
      blockSticky = true;
      stickyBar.classList.remove('sticky-atc-bar--show');
      setTimeout(() => { blockSticky = false; }, 500);
    });

    function update() {
      if (blockSticky) return;
      const rect = buyButton.getBoundingClientRect();
      const isButtonVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      if (isButtonVisible) {
        buttonHasBeenVisible = true;
        stickyBar.classList.remove('scrolled');
      } else if (buttonHasBeenVisible) {
        stickyBar.classList.add('scrolled');
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update(); // estado inicial, sin esperar al primer scroll
  }, 300);
})();

(function () {
  if (document.cookie.includes('chat_opened=true')) return;

  function setup(chat) {
    if (!chat.shadowRoot) return false;
    if (!chat.shadowRoot.getElementById('cv-no-badge')) {
      const style = document.createElement('style');
      style.id = 'cv-no-badge';
      style.textContent = '.activator__indicator { display: none !important; }';
      chat.shadowRoot.appendChild(style);
    }
    // El clic al botó intern travessa la frontera del shadow DOM
    chat.addEventListener('click', function () {
      document.cookie = 'chat_opened=true; path=/; max-age=31536000';
      const s = chat.shadowRoot.getElementById('cv-no-badge');
      if (s) s.remove();
    }, { once: true });
    return true;
  }

  const el = document.querySelector('shopify-chat');
  if (el && setup(el)) return;

  const obs = new MutationObserver(() => {
    const chat = document.querySelector('shopify-chat');
    if (chat && setup(chat)) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 15000);
})();